export const formatWeekRange = ({ weekStart, weekEnd, variant = 'label' }) => {
  if (!weekStart || !weekEnd) return '';

  const startDate = new Date(weekStart);
  const endDate = new Date(weekEnd);

  const monthStr = startDate
    .toLocaleString('en-US', { month: 'short' })
    .toUpperCase();

  if (variant === 'title') {
    return `Week Of ${monthStr} ${startDate.getDate()} - ${endDate.getDate()}`;
  }

  const startDay = String(startDate.getDate()).padStart(2, '0');
  const endDay = String(endDate.getDate()).padStart(2, '0');

  return `${monthStr} ${startDay}-${endDay}`;
};
export const calculateChartPoints = ({
  trends = [],
  config,
  containerWidth = 600
}) => {
  const {
    baseSvgWidth = 600,
    svgHeight = 200,
    padding = { top: 15, right: 25, bottom: 30, left: 25 },
    visibleCount = 6
  } = config;

  const dataCount = trends.length;
  const isScrollable = dataCount > visibleCount;

  const effectiveBaseWidth = isScrollable
    ? baseSvgWidth
    : Math.max(containerWidth, baseSvgWidth);

  const baseChartWidth = effectiveBaseWidth - padding.left - padding.right;
  const stepWidth = baseChartWidth / Math.max(visibleCount - 1, 1);

  const chartWidth = isScrollable
    ? (dataCount - 1) * stepWidth
    : baseChartWidth;

  const chartHeight = svgHeight - padding.top - padding.bottom;
  const computedSvgWidth = isScrollable
    ? chartWidth + padding.left + padding.right
    : effectiveBaseWidth;

  const points = trends.map((item, index) => {
    const x =
      dataCount > 1
        ? padding.left + (index / (dataCount - 1)) * chartWidth
        : padding.left + chartWidth / 2;

    const calculateY = (val) =>
      padding.top + chartHeight - ((val || 0) / 100) * chartHeight;

    return {
      x,
      celebrateY: calculateY(item.mastery_percentages?.celebrate),
      supportY: calculateY(item.mastery_percentages?.support),
      interveneY: calculateY(item.mastery_percentages?.intervene),
      data: item
    };
  });

  return {
    points,
    svgWidth: computedSvgWidth,
    isScrollable
  };
};

export const createPathD = ({ points, key }) => {
  if (!points || points.length < 2) return '';
  return points.reduce((acc, pt, idx) => {
    const y = pt[key];
    return idx === 0 ? `M ${pt.x} ${y}` : `${acc} L ${pt.x} ${y}`;
  }, '');
};
